module.exports = __webpack_public_path__ + "static/media/youtube.967fe779.svg";